const LOCAL_DESKTOP_CALLBACK_ORIGINS = ["http://127.0.0.1:3367", "http://127.0.0.1:24071"] as const;
const LOCAL_DESKTOP_CALLBACK_OPEN_PATH = "/open";
const LOCAL_DESKTOP_CALLBACK_TIMEOUT_MS = 750;

/**
 * Builds the loopback URL that hands a browser callback to a local desktop app.
 */
export const buildLocalDesktopCallbackUrl = ({
  origin = LOCAL_DESKTOP_CALLBACK_ORIGINS[0],
  url,
}: {
  origin?: string;
  url: URL;
}) => {
  const callbackUrl = new URL(LOCAL_DESKTOP_CALLBACK_OPEN_PATH, origin);
  callbackUrl.searchParams.set("url", url.toString());
  return callbackUrl;
};

/**
 * Attempts the local desktop handoff before falling back to the mem:// protocol.
 */
export const tryLocalDesktopCallbackHandoff = async ({ url }: { url: URL }): Promise<boolean> => {
  for (const origin of LOCAL_DESKTOP_CALLBACK_ORIGINS) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), LOCAL_DESKTOP_CALLBACK_TIMEOUT_MS);

    try {
      const response = await fetch(buildLocalDesktopCallbackUrl({ origin, url }).toString(), {
        cache: "no-store",
        credentials: "omit",
        method: "GET",
        mode: "cors",
        signal: controller.signal,
      });

      if (response.ok) {
        return true;
      }
    } catch {
      // Probe the fallback port when the primary listener is unavailable.
    } finally {
      window.clearTimeout(timeout);
    }
  }

  return false;
};
